import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Fragment, memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { RadioOption, } from './RadioOption';
const errorHeight = 22;
const groupLabelStyles = css `
  ${theme.typeStyles.titleMediumStyles}
  margin-bottom: ${theme.spacing.x3};
`;
const defaultProps = {
    name: '',
};
const RadioGroup = ({ border, disabled, error, hasErrorSpacing, horizontal, label, name = defaultProps.name, onChange, options, value, }) => {
    const groupErrorStyles = useMemo(() => (css `
        ${theme.typeStyles.bodySmallStyles}
        color: ${theme.colors.negative800};
        ${hasErrorSpacing && css `
          margin-top: ${theme.spacing.x2};
          min-height: ${styleUtils.rem(errorHeight)};
        `}
      `), [
        hasErrorSpacing,
    ]);
    const optionsContinerStyles = useMemo(() => (horizontal
        ? (css `
          display: flex;
          flex-direction: row;
        `)
        : null), [
        horizontal,
    ]);
    const optionStyles = useMemo(() => (css `
        padding-bottom: ${theme.spacing.x3};
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;

        &:last-child {
          padding-bottom: 0;
        }

        ${horizontal && css `
          padding-bottom: 0;
          padding-right: ${theme.spacing.x3};

          /* stylelint-disable-next-line  no-duplicate-selectors */
          &:last-child {
            padding-right: 0;
          }
        `}

        ${border && !horizontal && css `
          padding-top: ${theme.spacing.x3};

          &:first-child {
            padding-top: 0;
          }

          &:not(:first-child) {
            border-top: ${styleUtils.rem(1)} solid ${theme.colors.gray300};
          }
        `}
      `), [
        border,
        horizontal,
    ]);
    const radioOptions = useMemo(() => (options
        .map(({ ariaChecked, ariaDescribedBy, ariaLabel, ariaLabelledBy, description, disabled: optionDisabled, id, label: optionLabel, value: optionValue, }) => {
        const disabledState = disabled || optionDisabled;
        const isChecked = value === optionValue;
        const itemId = id || optionValue;
        const key = name + itemId;
        return (_jsx("div", Object.assign({ css: optionStyles }, { children: _jsx(RadioOption, { ariaChecked: ariaChecked, ariaDescribedBy: ariaDescribedBy, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, description: description, disabled: disabledState, id: key, isChecked: isChecked, label: optionLabel, name: name, onChange: onChange, value: optionValue }) }), key));
    })), [
        disabled,
        name,
        onChange,
        options,
        optionStyles,
        value,
    ]);
    return (_jsxs(Fragment, { children: [label && (_jsx("div", Object.assign({ css: groupLabelStyles }, { children: label }))), _jsx("div", Object.assign({ css: optionsContinerStyles }, { children: radioOptions })), _jsx("div", Object.assign({ css: groupErrorStyles }, { children: error }))] }));
};
const MemoizedRadioGroup = memo(RadioGroup);
export { MemoizedRadioGroup as RadioGroup };
// MC-1068 Temporary hack for Storybook.
export default RadioGroup;
